"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-aspect-ratio";
//#region src/components/atoms/AspectRatio/AspectRatio.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "aspect-ratio",
	...e,
	ref: r
}));
r.displayName = "AspectRatio";
//#endregion
export { r as AspectRatio };
